// extracted by mini-css-extract-plugin
module.exports = {"stepper":"stepper_stepper__2LlUv","img":"stepper_img__1cq-J"};